import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "AdministrationStatus" }
const _hoisted_2 = { class: "AdministrationStatus__label" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "AdministrationStatus__statuses" }

import { PropType, computed } from "vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { AdministrationStatus } from "@/types";
import Status from "@/components/general/administration-status/Status.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdministrationStatus',
  props: {
    actionLabel: {
        type: String,
        required: true,
    },
    doneLabel: {
        type: String,
        required: true,
    },
    statuses: {
        type: Array as PropType<AdministrationStatus[]>,
        required: true,
    },
},
  emits: ["action"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const overallStatus = computed(() => {
    if (props.statuses.every((status) => status.done === "success")) {
        return "done";
    } else if (props.statuses.every((status) => status.done === "idle")) {
        return "idle";
    } else {
        return "busy";
    }
});

const doAction = () => {
    emit("action");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (overallStatus.value === 'done')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.doneLabel), 1))
        : _createCommentVNode("", true),
      (overallStatus.value === 'idle')
        ? (_openBlock(), _createBlock(IconButton, {
            key: 1,
            onClick: doAction,
            "icon-id": "share"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.actionLabel), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (overallStatus.value === 'busy')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "..."))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.statuses, (status, index) => {
        return (_openBlock(), _createBlock(Status, {
          status: status,
          key: index
        }, null, 8, ["status"]))
      }), 128))
    ])
  ]))
}
}

})